var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerbi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "zlT103XX9RAwCGfF9JpW0a",
    x1: 32,
    x2: 32,
    y1: 3.947,
    y2: 44.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ebb112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb5c17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zlT103XX9RAwCGfF9JpW0a)",
    d: "M27,44h10c1.105,0,2-0.895,2-2V6c0-1.105-0.895-2-2-2H27c-1.105,0-2,0.895-2,2v36 C25,43.105,25.895,44,27,44z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "zlT103XX9RAwCGfF9JpW0b",
    x1: 22.089,
    x2: 26.009,
    y1: 13.14,
    y2: 45.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#f6c648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#e3a513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#de9d06"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zlT103XX9RAwCGfF9JpW0b)",
    d: "M19,44h10c1.105,0,2-0.895,2-2V16c0-1.105-0.895-2-2-2H19c-1.105,0-2,0.895-2,2v26 C17,43.105,17.895,44,19,44z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "zlT103XX9RAwCGfF9JpW0c",
    x1: 9.803,
    x2: 21.335,
    y1: 22.781,
    y2: 43.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#ffdf26"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zlT103XX9RAwCGfF9JpW0c)",
    d: "M11,44h10c1.105,0,2-0.895,2-2V26c0-1.105-0.895-2-2-2H11c-1.105,0-2,0.895-2,2v16 C9,43.105,9.895,44,11,44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbi);
export default __webpack_public_path__ + "static/media/powerbi.8ae7d70089e3fe0c240115e4f44016e5.svg";
export { ForwardRef as ReactComponent };